<div class="page-wrapper">
  <a class="back-arrow-inner" style="cursor: pointer" (click)="navigateBackToMemberSearch()"><mat-icon
  matListIcon>arrow_back</mat-icon> Member Search</a>
  <!-- Page Header -->
  <div class="page-header">
    <h2>Print ID Card</h2>
  </div>

  @if (selectedMemberDetails$ | async; as selectedMemberDetails) {
    <!-- Member Detail card -->
    <div class="detail-card mar-b-15">
      <div class="client-id-name">
        <h4>Member</h4>
        <span>(Client: {{selectedMemberDetails.clientId}}-{{selectedMemberDetails.client_full_name}})</span>
      </div>
      <div class="mat-row">
        <div class="mat-2">
          <label class="card-label">Name</label>
          <p>
            {{ selectedMemberDetails.firstName }}
            {{ selectedMemberDetails.lastName }}
          </p>
        </div>
        <div class="mat-2">
          <label class="card-label">Person Code</label>
          <p>{{ selectedMemberDetails.personCode }}</p>
        </div>
        <div class="mat-2">
          <label class="card-label">DOB</label>
          <p>{{ selectedMemberDetails.DOB | timeStampToDate }}</p>
        </div>
        <div class="mat-2">
          <label class="card-label">Relationship</label>
          <p>{{selectedMemberDetails.relationshipCode}} - {{relationShip[selectedMemberDetails.relationshipCode] }}</p>
        </div>
        <div class="mat-2">
          <label class="card-label">Card/Alt ID</label>
          <p>{{ selectedMemberDetails.cardId }}</p>
        </div>
        <div class="mat-2">
          <label class="card-label">Coverage Type</label>
          <p>
            {{
            displayCoverageType[selectedMemberDetails?.coverage?.coverageType]
            }}
          </p>
        </div>
      </div>
    </div>
    <h3 class="form-heading">Digital ID Card</h3>
    @if (isIdCardAvailable) {
      <div class="print-card-wrapper">
        <span>
          <img [src]="imageUrl | sanitizeHtml: 'url'" alt="print card" />
        </span>
      </div>
    }
    @if (!isIdCardAvailable && selectedMemberDetails) {
      <div class="print-card-wrapper">
        <div class="slimmed-id-card">
          <img class="brand" src="../../../../assets/images/brand-logo/logo.svg" width="75" alt="EmpiRx">
          <div class="id-data">
            <div class="mb-40">
              <label>ID</label>
              <p class="id">{{ selectedMemberDetails?.cardId }}</p>
            </div>
            <div>
              <label>Name</label>
              <p class="name">{{ selectedMemberDetails?.firstName }}
              {{ selectedMemberDetails?.lastName }}</p>
            </div>
            <div class="mat-row">
              <div class="mat-5">
                <label>RXBIN</label>
                <p>024160</p>
              </div>
              <div class="mat-5">
                <label>RXPCN</label>
                <p>14032015</p>
              </div>
              <div class="mat-5">
                <label>RXGRP</label>
                <p>{{ externalClientIdsMapping[selectedMemberDetails?.clientId]?
                externalClientIdsMapping[selectedMemberDetails?.clientId]: selectedMemberDetails?.clientId}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }
  @if (!isIdCardAvailable) {
    <div class="note-wrapper">
      <p>
        Note: This is a temporary ID card, the permanent digital card will be generated in 24 to 48 hours.
      </p>
    </div>
  }
  <div class="mat-row button-row" fxLayout="row">
    <div class="mat-12" fxLayoutAlign="end end">
      @if (isIdCardAvailable) {
        <button mat-button class="primary-btn" (click)="downloadImage()">
          Download ID
        </button>
      }
      @if (isIdCardAvailable) {
        <button mat-button class="secondary-btn" (click)="openPrintWindow()">
          Print ID
        </button>
      }
      <button mat-button class="secondary-btn" (click)="navigateBackToMemberSearch()">
        Cancel
      </button>
    </div>
  </div>
</div>